import React from 'react';

import utils from '../../../services/utils';
import Button from '../../Buttons/Button/Button';
import FieldBold from '../../Fields/FieldBold/FieldBold';
import Tags from '../../Tags/Tags';
import { documentTypesAbbreviationsObject } from '../../../store/catalogs/documentTypes';
import ResultOrigin from '../ResultOrigin/ResultOrigin';
import { ReactComponent as CircleExclamation } from '../../../assets/icons/CircleExclamation.svg';
import { ReactComponent as TwoArrowsReload } from '../../../assets/icons/TwoArrowsReload.svg';
import Tooltip from '../../Tooltip/Tooltip';
import ShowArrowButton from '../../Buttons/ShowArrowButton/ShowArrowButton';
import { statusAccountLabel, typesStatusAccount } from '../../../store/constants/statusDruoAccounts';

import classes from './AgreementResult.module.scss';
import NoticeCard from '../../NoticeCard/NoticeCard';

const AgreementResult = ({
  agroupAgreementsState,
  dataPayAgreement,
  showDetailsAgreements,
  methodForPay,
  setAgroupAgreementsState,
  costTransaction
}) => {
  const showInvoices = idx => {
    setAgroupAgreementsState(agreementsState => {
      let agreementAux = [...agreementsState];
      agreementAux[idx] = { ...agreementAux[idx], isShowInvoices: !agreementAux[idx].isShowInvoices };
      return agreementAux;
    });
  };
  return (
    <>
      <ResultOrigin
        methodForPay={methodForPay}
        datePay={dataPayAgreement.creationDate}
        origin={
          methodForPay === 'PSEPay'
            ? dataPayAgreement.psePayins.map(origin => ({
                bankAccount: {
                  bankId: 'PSE',
                  name: origin.name,
                  endUser: {
                    identificationTypeLabel: documentTypesAbbreviationsObject[origin.identificationType],
                    identificationNumber: origin.identificationNumber
                  }
                }
              }))
            : dataPayAgreement.druoPayments.map(origin => ({
                value: origin.withdrawedValue,
                bankAccount: {
                  bankId: origin.sourceBankDruoId,
                  subtypeLabel: origin.sourceBankAccountTypeLabel,
                  bankLast4Digits: `****${origin.sourceBankAccountNumber}`,
                  name: origin.sourceBankOwnerName,
                  endUser: {
                    identificationTypeLabel: origin.sourceBankOwnerIdentificationTypeLabel,
                    identificationNumber: origin.sourceBankOwnerIdentificationNumber
                  }
                }
              }))
        }
      />

      <div className={classes['business']}>
        <span className={`${classes['business-span']} medium-12`}>EMPRESAS O SERVICIOS</span>
        {agroupAgreementsState.map((agreement, idx) => (
          <div key={idx} className={classes.agreement}>
            <span className='semibold-18'>{agreement.agreementName}</span>
            <div className={classes['agreement-space-total']}>
              <FieldBold
                title='CANTIDAD DE CUENTAS DE COBRO'
                value={`${agreement.invoices.length} cuenta${agreement.invoices.length > 1 ? "s" : ""}`}
              />
              <FieldBold title='TOTAL A PAGAR' value={utils.moneyFormat(agreement.totalToPay)} />
            </div>
            <div className={classes['agreement-space-invoices']}>
              <span className='semibold-16'>Cuentas</span>
              <ShowArrowButton
                onClick={() => showInvoices(idx)}
                showState={agreement.isShowInvoices}
                iconPosition='left'
                color='gray'
              />
            </div>
            {agreement.isShowInvoices && (
              <div className={classes.invoices}>
                {agreement.invoices.map((invoice, idx) => (
                  <div key={idx} className={classes.invoice}>
                    <div className={classes.head}>
                      <FieldBold classValue='text-ellipsis' title='DESCRIPCIÓN' value={invoice.description} />
                      <Tags text={statusAccountLabel[invoice.meloStatus].label} type={statusAccountLabel[invoice.meloStatus].color} />
                    </div>
                    <div className={classes['invoice-total']}>
                      <FieldBold title='NÚMERO DE REFERENCIA' value={invoice.number} />
                      <FieldBold title='TOTAL A PAGAR' value={utils.moneyFormat(invoice.valueToPay)} />
                    </div>
                    {typesStatusAccount.ERROR !== invoice.meloStatus ? (
                      <Button onClick={() => showDetailsAgreements(invoice, agreement.agreementName)} custom='quaternary'>
                        Ver detalles
                      </Button>
                    ) : (
                      <>
                        <NoticeCard
                          className={classes.notice}
                          isNotButton={true}
                          type='failed'
                          text='El pago de esta cuenta de cobro no pudo ser procesado. Verifica las cuentas origen y destino. Vuelve a intentar el pago y si el error persiste escríbenos a soporte@melo.com.'
                        />
                        <Button Icon={TwoArrowsReload} custom='quaternary'>
                          Reintentar pago
                        </Button>
                      </>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
        {/* {agroupAgreementsState.map((agreement, idx) => {
          const isOneInvoices = agreement.invoices.length === 1;

          const meloStatus = isOneInvoices ? agreement.invoices[0].meloStatus : '';
          const statusDescription = isOneInvoices ? agreement.invoices[0].statusDescription : '';

          return (
            <div key={idx} className={classes['card-agreement']}>
              <div className={`${classes['margin-text-card']} ${classes.head}`}>
                <span className='semibold-18 text-ellipsis'>{agreement.agreementName}</span>
                {isOneInvoices && (
                  <div className={classes.tag}>
                    <Tags text={statusAccountTransaction[meloStatus]?.label} type={statusAccountTransaction[meloStatus]?.color} />
                    <Tooltip
                      classNameChildren={classes.tooltip}
                      content={`${statusAccountTransaction[meloStatus].tooltip} ${
                        meloStatus === typesStatusAccount.ERROR ? statusDescription || '' : ''
                      }`}>
                      <CircleExclamation />
                    </Tooltip>
                  </div>
                )}
              </div>
              
          );
        })} */}
      </div>
      <div className={classes.totals}>
        <div className={`${classes['total-detail']} ${classes.space}`}>
          <div className={classes.tooltip}>
            <span className='medium-14'>Cobro por transacción:</span>
            <Tooltip
              classNameChildren={classes.tooltip}
              position='bottom-left'
              content={`Una transacción es un movimiento que se realiza a una cuenta bancaria. Si haces pagos múltiples, estas son varias transacciones con un costo de ${utils.moneyFormat(
                dataPayAgreement.transactionsCost
              )} cada una.`}>
              <CircleExclamation />
            </Tooltip>
          </div>
          <span className='medium-14'>
            <span style={{ textDecoration: 'line-through', opacity: 0.7 }}>
              {utils.moneyFormat(dataPayAgreement.transactionsCost || (costTransaction * (dataPayAgreement.totalAgreements || 1)))}
            </span>
          </span>
        </div>
        <div className={classes.space}>
          <span className='medium-14'>Total de las cuentas de cobro:</span>
          <span className='medium-14'>{utils.moneyFormat(dataPayAgreement.subtotalValue)}</span>
        </div>
        <div className={`${classes.space} ${classes.total}`}>
          <span className='semibold-20'>TOTAL</span>
          <span className='semibold-20'>{utils.moneyFormat(dataPayAgreement.totalValue)}</span>
        </div>
      </div>
    </>
  );
};

export default AgreementResult;
